export enum DoorRecommendation {
    Standard = 0,
    DistantRelative = 1,
    CloseFamilyMember = 2,
    ExactMatch = 3,
    CustomerSelection = 4,
}

